<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="Mail Address List"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          class="icon-pencil1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
      <template v-slot:customerType="{ tableRow }">
        {{ getCustomerType(tableRow.row.customerType) }}
      </template>
    </table-view>

    <!-- 新增/编辑弹窗   -->
    <el-dialog
      :visible.sync="visible"
      :title="form.id ? 'Edit' : 'Add'"
      width="462px"
      @close="handleClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-form-item label="GEO" prop="geo">
            <el-select v-model="form.geo" style="width: 100%" :clearable="true">
              <el-option
                v-for="item in geoList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Region" prop="region">
            <el-select
              v-model="form.region"
              style="width: 100%"
              :clearable="true"
            >
              <el-option
                v-for="item in regionList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Customer Type" prop="customerType">
            <el-select v-model="form.customerType" style="width: 100%">
              <el-option label="Trade" :value="1" />
              <el-option label="Eaas" :value="2" />
              <el-option label="Saas" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="IT Code" prop="username">
            <el-input style="width: 100%" v-model="form.username" />
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input style="width: 100%" v-model="form.email" />
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSave">
          Save
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTableData, updateOrAdd, getOptionList, removeItem } from './api'

export default {
  data() {
    return {
      searchModel: [
        {
          label: 'GEO',
          type: 'select',
          key: 'geo',
          selectList: [],
          defaultValue: '',
        },
        {
          label: 'Region',
          type: 'select',
          placeholder: 'All',
          key: 'region',
          selectList: [],
        },
        {
          label: 'IT Code',
          type: 'input',
          key: 'username',
          defaultValue: '',
        },
      ],
      tableModel: [
        {
          label: 'GEO',
          prop: 'geoStr',
        },
        {
          label: 'Region',
          prop: 'regionStr',
        },
        {
          label: 'Customer Type',
          slotName: 'customerType',
        },
        {
          label: 'IT Code',
          prop: 'username',
        },
        {
          label: 'Email',
          prop: 'email',
        },
        {
          label: 'Action',
          width: 120,
          slotName: 'action',
        },
      ],
      tableData: [],
      pages: {},
      visible: false,
      form: {
        id: '',
        geo: '',
        region: '',
        email: '',
        username: '',
        customerType: 1,
      },
      rules: {
        geo: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        customerType: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        region: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        email: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        username: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
      },
      geoList: [],
      regionList: [],
    }
  },
  mounted() {
    this._getOptionList()
    this.initTable()
  },
  methods: {
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const newParams = { ...params }
        Object.keys(newParams).forEach(key => {
          if (!newParams[key]) {
            delete newParams[key]
          }
        })
        const { data, page } = await getTableData(newParams)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    async _getOptionList() {
      try {
        this.geoList = await getOptionList({
          typeMark: 'geo',
        })
        this.searchModel[0].selectList = this.geoList
        this.regionList = await getOptionList({
          typeMark: 'region',
        })
        this.searchModel[1].selectList = this.regionList
      } catch (err) {
        console.error(err)
      }
    },
    getCustomerType(type) {
      const t = Number(type)
      switch (t) {
        case 1:
          return 'Trade'
        case 2:
          return 'Eaas'
        case 3:
          return 'Saas'
        default:
          return ''
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleClose() {
      this.form.id = ''
      this.form.customerType = 1
      this.$refs.form.resetFields()
    },
    async handleSave() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          const submitData = { ...this.form }
          // ensure customerType is numeric
          if (submitData.customerType !== undefined && submitData.customerType !== null) {
            submitData.customerType = Number(submitData.customerType)
          }
          await this.handleUpdateOrAdd(submitData)
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleUpdateOrAdd(params) {
      try {
        await updateOrAdd(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      this.visible = true
    },
    async handleEdit(row) {
      this.visible = true
      this.$nextTick(() => {
        Object.keys(this.form).forEach(key => {
          if (key === 'customerType') {
            this.form.customerType =
              row.customerType !== undefined && row.customerType !== null
                ? Number(row.customerType)
                : this.form.customerType
          } else {
            this.form[key] = row[key] !== undefined ? row[key] : this.form[key]
          }
        })
      })
    },
    async handleRemoveItem(id) {
      try {
        await removeItem(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
